<template>
  <div class="content">
    <el-tabs class="tabLv3 relaAlarm" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="jsgl">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 告警批量处理
        </span>
        <div class="normalNav zaddBtn">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
          <button class="BtnSmPurple" @click="handleAll">批量处理</button>
        </div>
        <div class="searchForm1 alarmSearchForm">
          <el-form :class="className">
            <el-form-item label="设备编号">
              <el-input
                placeholder="请输入设备编号"
                v-model.trim="searchForm.deviceId"
                type="text"
              ></el-input>
            </el-form-item>
            <el-form-item label="设备名称">
              <el-input
                placeholder="请输入设备名称"
                v-model.trim="searchForm.deviceName"
                type="text"
              ></el-input>
            </el-form-item>
            <el-form-item label="告警开始时间">
              <el-date-picker
                v-model="searchForm.startTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="告警结束时间">
              <el-date-picker
                v-model="searchForm.endTime"
                type="datetime"
                placeholder="选择日期时间"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
              >
              </el-date-picker>
            </el-form-item>
            <el-form-item label="区域">
              <el-input
                placeholder="请选择区域"
                v-model="searchForm.curAreaName"
                @focus="changeAreaMode(1)"
              ></el-input>
            </el-form-item>
            <el-form-item label="管理部门">
              <el-input
                placeholder="请选择部门"
                v-model="searchForm.companyName"
                @focus="$refs.companyDialg.look()"
              ></el-input>
              <!-- <el-cascader v-model="searchForm.deptId" :options="managerArr" :props="{value:'id',label:'name',children:'children'}" placeholder="请选择"></el-cascader> -->
            </el-form-item>
            <el-form-item label="处理人">
              <el-input
                placeholder="请输入处理人"
                v-model.trim="searchForm.handler"
                type="text"
              ></el-input>
            </el-form-item>
            <el-form-item label="应用系统">
              <el-select
                v-model="searchForm.operatingSystemId"
                placeholder="请选择"
                @change="bindSystem"
              >
                <el-option
                  v-for="item in systemArr"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="设备类型">
              <el-select v-model="searchForm.deviceTypeId" placeholder="请选择">
                <el-option
                  v-for="item in deviceOptions"
                  :key="item.id"
                  :label="item.typeName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="告警等级">
              <el-select v-model="searchForm.alarmLevelId" placeholder="请选择">
                <el-option
                  v-for="item in gradeOptions"
                  :key="item.value"
                  :label="item.name"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <template>
              <span class="collapseIcon" @click="className = 'expand'"
                ><img v-default-img
                  :src="require('../../../../../public/searchForm/collapse.png')"
                  alt=""
              /></span>
              <span class="expandIcon" @click="className = 'collapse'"
                ><img v-default-img
                  :src="require('../../../../../public/searchForm/expand.png')"
                  alt=""
              /></span>
            </template>
            <!-- </searchForm> -->
          </el-form>
        </div>
        <div class="tableWrapper" v-loading="!showTable">
          <!-- 后端分页 -->
          <el-table :data="tableData" class="stripeTable" stripe>
            <el-table-column
              show-overflow-tooltip
              v-for="{ prop, label } in tableLable"
              :key="prop.toString()"
              :label="label"
              :prop="prop"
              :render-header="labelHead"
            >
            </el-table-column>
            <el-table-column
              :formatter="formatter"
              show-overflow-tooltip
              label="告警状态"
              prop="alarmStatus"
            >
            </el-table-column>
            <el-table-column
              show-overflow-tooltip
              label="领取时间"
              prop="pickTime"
              width="150"
            >
            </el-table-column>
            <!-- <el-table-column label="操作" width="200" align="left">
              <template slot-scope="scope">
                <el-link
                  icon="iconfont iconwhole"
                  type="text"
                  size="small"
                  @click="
                    $refs.alarmDetail.look(scope.$index, scope.row, false)
                  "
                  >详情</el-link
                >
                <more-scope
                  ref="moreScope"
                  :row="scope.row"
                  @handOut="handOut"
                  @bShangbao="bShangbao"
                  @controlBtn="controlBtn"
                ></more-scope>
              </template>
            </el-table-column> -->
          </el-table>
          <div class="footer">
            <el-pagination
              layout="prev, pager, next"
              :page-size="10"
              :current-page.sync="currentPage"
              @current-change="handleCurrentChange"
              :total="nTotal"
            >
            </el-pagination>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <mountPoint
      :hasChildNodes="areaTreeMode"
      :dialogVisible="areaTreeVisible"
      @regionTreeClose="areaTreeVisible = false"
      @regionTreeData="selRegionData"
    ></mountPoint>
    <company-dialog ref="companyDialg"></company-dialog>
    <!-- <alarm-detail ref="alarmDetail"></alarm-detail> -->
    <alarm-dialog ref="alarmDialog"></alarm-dialog>
  </div>
</template>
<script>
import { dt, obj2urlsp } from "utils";
export default {
  data() {
    return {
      className: "collapse",
      tabName: "jsgl",
      fullApply: [],
      CityInfo: [],
      loading: true,
      form_jsgl: {},
      items: [],
      searchForm: {
        deviceId: "",
        deviceName: "",
        curAreaName: "",
        companyName: "",
        startTime: "",
        endTime: "",
        areaId: null,
        // deptId: null,
        handler: "",
        operatingSystemId: null,
        deviceTypeId: null,
        alarmLevelId: null,
      },
      iconflag: false,
      form_yhgl: {},
      deviceOptions: [],
      gradeOptions: [],

      showTable: true,
      //前端分页
      showTable2: false,
      data: {},
      tableLable: [
        {
          prop: "areaNames",
          label: "区域",
        },
        {
          prop: "dept",
          label: "管理部门",
        },
        {
          prop: "operatingSystemName",
          label: "应用系统",
        },
        {
          prop: "deviceTypeName",
          label: "设备类型",
        },
        {
          prop: "deviceName",
          label: "设备名称",
        },
        {
          prop: "startTime",
          label: "告警开始时间",
        },
        // {
        //   prop: "endTime",
        //   label: "告警恢复时间",
        // },
        // {
        //   prop: "continueTime",
        //   label: "持续时间",
        // },
        {
          prop: "alarmDesc",
          label: "告警内容",
        },
        {
          prop: "alarmLevelName",
          label: "告警等级",
        },
      ],
      handleLable: ["处理结果", "处理说明"],
      handleOptions: [
        {
          label: "误报",
          value: 0,
        },
        {
          label: "告警",
          value: 1,
        },
      ],
      reportLable: ["上报单位", "上报说明"],
      reportOptions: [
        {
          label: "单位1",
          value: 0,
        },
        {
          label: "单位2",
          value: 1,
        },
      ],
      handType: "待派发",
      pagesize: 10,
      currentPage: 1,
      nTotal: 0,
      tableData: [],
      plugIns: [],
      areaArr: [],
      systemArr: [],
      managerArr: [],
      flagShow: true,
      //区域树是否显示
      areaTreeVisible: false,
      inputReadOnly: false,
      //区域树模式选择
      areaTreeMode: true,
      //选择区域树模式 查询 ？ 新增 ？
      areaMode: 1,
    };
  },
  computed: {},
  methods: {
    formatter(row, column) {
      return row.alarmStatus == 0
        ? "待派发"
        : row.alarmStatus == 1
        ? "待领取"
        : row.alarmStatus == 2
        ? "上报待领取"
        : row.alarmStatus == 3
        ? "待处理"
        : "已处理";
    },
    handOut(row) {
      if (row.alarmStatus == 0 || row.alarmStatus == 1 || row.alarmStatus == 2)
        this.deleteMsg(row);
      else
        this.$refs.alarmDialog.handle(
          row,
          this.handleLable,
          this.handleOptions
        );
    },
    //选择区域模式变化
    changeAreaMode(mode) {
      this.areaTreeVisible = true;
      if (mode === 1) this.areaTreeMode = true;
      if (mode === 2) this.areaTreeMode = false;
      this.areaMode = mode;
    },
    //区域树选择完回调
    selRegionData(a, ...b) {
      let mode = this.areaMode;
      if (mode === 1) {
        this.searchForm.areaId = a.id;
        this.searchForm.curAreaName = a.name;
      }
    },
    bShangbao(row) {
      this.$refs.alarmDialog.report(row, this.reportLable);
    },
    controlBtn(row) {
      this.$router.push({
        path: "/detail",
        query: {
          id: row.id,
          deviceId: row.deviceId,
          deviceType: row.deviceTypeId,
          pname: row.operatingSystemName,
          cname: row.deviceTypeName,
          dname: row.deviceName,
          tabName: 3,
        },
      });
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getInfoDate(val, this.pagesize);
    },
    handleSizeChange(val) {
      this.currentPage = val;
      this.getInfoDate(val, this.pagesize);
    },
    // 应用系统
    getSystem() {
      this.$axiosget(
        "manager/operatingSystemApi/getOperatingSystemsByCompanyId?compayId=".concat(
          localStorage.getItem("companyId")
        )
      ).then((res) => {
        this.systemArr = res.data.data;
      });
    },
    getTreeData(data) {
      for (var i = 0; i < data.length; i++) {
        if (data[i].children.length == 0) {
          // children若为空数组，则将children设为undefined
          data[i].children = undefined;
        } else {
          // children若不为空数组，则继续 递归调用 本方法
          this.getTreeData(data[i].children);
        }
      }
      return data;
    },
    // 应用系统关联设备类型
    bindSystem() {
      if (this.searchForm.operatingSystemId != null) {
        this.searchForm.deviceTypeId = null;
        this.$axiosget(
          "manager/devicetype/getTypesByOperatingSystemId?operatingSystemId=".concat(
            this.searchForm.operatingSystemId
          )
        ).then((res) => {
          this.deviceOptions = res.data.data;
        });
      }
    },
    // 告警等级
    getAlarm() {
      this.$axiosget("operation/dictionaryData/queryByKey?key=alarmLevel").then(
        (res) => {
          this.gradeOptions = res.data.data;
        }
      );
    },
    //    获取后台数据
    getInfoDate(page, pagesize) {
      //console.log("搜索");
      let formData = JSON.parse(JSON.stringify(this.searchForm));
      // formData.deptId =
      //   formData.deptId.length > 0
      //     ? formData.deptId.splice(formData.deptId.length - 1)[0]
      //     : null;
      this.$axiospost("operation/deviceAlarmApi/getBatchAlarmNowPageList", {
        ...formData,
        pageNum: page,
        pageSize: pagesize,
      }).then((res) => {
        this.tableData = res.data.data.list;
        this.nTotal = res.data.data.total;
        this.flagShow = true;
      });
    },
    //批量处理
    handleAll() {
      let formData = JSON.parse(JSON.stringify(this.searchForm));
      this.$confirm("是否确定批量处理？", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        this.$axiospost("operation/deviceAlarmApi/batchHandleAlarm", {
          ...formData,
        }).then((res) => {
          if (res.data.status == "10000") {
            this.subSeefrom();
            this.$message.success(res.data.message);
          }
        });
      });
    },
    // 表头全显
    labelHead(h, { column, index }) {
      let l = column.label.length;
      let f = 21; //每个字大小，其实是每个字的比例值，大概会比字体大小差不多大一点，
      column.minWidth = f * l; //字大小乘个数即长度 ,注意不要加px像素，这里minWidth只是一个比例值，不是真正的长度 //然后将列标题放在一个div块中，注意块的宽度一定要100%，否则表格显示不完全
      return h("div", { class: "table-head", style: { width: "100%" } }, [
        column.label,
      ]);
    },

    reset() {
      this.searchForm = {
        deviceId: "",
        curAreaName: "",
        startTime: "",
        endTime: "",
        areaId: null,
        deptId: null,
        companyName: "",
        handler: "",
        operatingSystemId: null,
        deviceTypeId: null,
        alarmLevelId: null,
      };
      this.pageNum = 1;
    },
    subSeefrom() {
      this.flagShow = false;
      this.getInfoDate(this.currentPage, this.pagesize);
    },

    report() {
      this.$refs.alarmDialog.handle(row, this.handleLable, this.handleOptions);
    },
    control() {},
    deleteMsg(row) {
      let title =
        row.alarmStatus == 0
          ? "派发"
          : row.alarmStatus == 1 || row.alarmStatus == 2
          ? "领取"
          : "";
      this.$confirm("确定" + title + "?", "", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        confirmButtonClass: "confirmButton",
        cancelButtonClass: "cancelButton",
        type: "warning",
      })
        .then(() => {
          let url = "operation/deviceAlarmApi/pickupAlarm";
          // title == "领取" ? "" : "";
          this.$axiospost(
            url,
            obj2urlsp({ id: row.id, userId: this.$store.state.user.phone })
          )
            .then((res) => {
              if (res.data.status == "10000") {
                this.$message.success(`${title}成功！`);
                this.getInfoDate(this.currentPage, this.pagesize);
              } else {
                this.$message.success(res.data.message);
              }
            })
            .catch((res) => {
              this.$message.success(res.message);
            });
        })
        .catch(() => {
          this.$message.warning("已取消操作");
        });
    },
  },
  components: {
    alarmDialog: () => import("./alarmDialog"),
    searchForm: () => import("public/searchForm"),
    mountPoint: () => import("public/mountPoint"),
  },
  mounted() {
    this.getSystem();
    this.getAlarm();
    this.getInfoDate(this.currentPage, this.pagesize);
  },
  created() {},
};
</script>

<style lang='less' >
.alarmSearchForm .el-form .el-form-item__label {
  width: 120px !important;
}
.alarmSearchForm .el-form-item {
  // display: flex !important;
}
.alarmSearchForm .el-date-editor.el-input {
  width: auto;
}
.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: rgba(0, 0, 0, 0.2) !important;
}
.el-table__body tr.hover-row.current-row > td,
.el-table__body tr.hover-row.el-table__row--striped.current-row > td,
.el-table__body tr.hover-row.el-table__row--striped > td,
.el-table__body tr.hover-row > td {
  background-color: rgba(0, 0, 0, 0.2) !important;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/ToolManagement/handleAllAlarm/index.vue